<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M2.33327 8.33337L2.33325 13.6667H13.6666V8.33337M2.33327 8.33337H5.33325M2.33327 8.33337L2.33329 2.33338L13.6666 2.33337V8.33337M10.6666 8.33337L13.6666 8.33337"
    stroke="currentColor"
    stroke-linecap="square"
  />
  <path
    d="M10.6666 8C10.6666 9.47276 9.47268 10.6667 7.99992 10.6667C6.52716 10.6667 5.33325 9.47276 5.33325 8"
    stroke="currentColor"
  />
</svg>
